import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import BadmintonTradesPage from './BadmintonTradesPage';
import TradeSubscriptionMatchNotification from './TradeSubscriptionMatchNotification';
import registerIndexSidebar from './indexSidebar';
import IndexPage from 'flarum/forum/components/IndexPage';
import SessionDropdown from 'flarum/forum/components/SessionDropdown';
import LogInModal from 'flarum/forum/components/LogInModal';
import SignUpModal from 'flarum/forum/components/SignUpModal';

function getSearchParam(name) {
  try {
    const url = new URL(window.location.href);
    return url.searchParams.get(name);
  } catch (e) {
    return null;
  }
}

app.initializers.add('acme-pku-badminton-routes', () => {
  app.routes['acme.badminton.trades'] = {
    path: '/badminton/trades',
    component: BadmintonTradesPage,
  };

  // 为“请登录/注册”的提示提供可点击跳转链接（无需 WebView）
  app.routes['acme.auth.login'] = {
    path: '/login',
    component: {
      oninit() {
        app.modal.show(LogInModal);
        m.route.set(app.route('index'));
      },
      view() {
        return null;
      },
    },
  };
  app.routes['acme.auth.register'] = {
    path: '/register',
    component: {
      oninit() {
        app.modal.show(SignUpModal);
        m.route.set(app.route('index'));
      },
      view() {
        return null;
      },
    },
  };
});

registerIndexSidebar();

function isCommunityReadOnlyUser() {
  // 按权限（非 CSS）控制：当用户在“当前上下文（全站/某个标签）”无发帖权限时，把“社区论坛”视为只读资讯流。
  // 说明：
  // - 全站权限：forum attribute canStartDiscussion
  // - 标签权限：Tag model attribute canStartDiscussion（由 flarum/tags 提供）
  // - 未登录用户：不强行隐藏（让 Flarum 自己弹登录框/按站点策略处理）
  // - 管理员：始终可见
  if (!app.session.user) return false;
  if (app.session.user.isAdmin && app.session.user.isAdmin()) return false;

  // 若当前是标签页（/t/...），优先看标签的发帖权限
  try {
    const cur = m.route.get ? m.route.get() : '';
    if (cur && (cur.startsWith('/t/') || cur.startsWith('/tags/'))) {
      const tagsParam = (m.route.param && m.route.param('tags')) || '';
      const slug = String(tagsParam || '').split('/')[0];
      if (slug) {
        const tag = app.store.all('tags').find((t) => t && (String(t.slug && t.slug()) === slug || String(t.id && t.id()) === slug));
        if (tag && typeof tag.canStartDiscussion === 'function') {
          return !tag.canStartDiscussion();
        }
      }
    }
  } catch (e) {
    // ignore
  }

  return !app.forum.attribute('canStartDiscussion');
}

app.initializers.add('acme-pku-badminton', () => {
  app.notificationComponents.tradeSubscriptionMatch = TradeSubscriptionMatchNotification;

  // 兼容旧链接：/?badminton_trades=1 → 独立页
  const trigger = getSearchParam('badminton_trades');
  if (trigger === '1') {
    m.route.set(app.route('acme.badminton.trades'));
  }
});

/**
 * “无发帖权限用户”前台模式：把社区当做“最新资讯”只读入口，隐藏发帖/回复相关 UI，
 * 并在个人下拉里隐藏“个人主页/设置”，只保留退出。
 */
app.initializers.add('acme-pku-badminton-readonly-community', () => {
  // 首页：隐藏发帖按钮，弱化社区入口为“最新资讯”
  extend(IndexPage.prototype, 'sidebarItems', function (items) {
    if (!isCommunityReadOnlyUser()) return;
    items.remove('newDiscussion');
  });

  // 首页：隐藏“排序/最新回复”等工具栏（保留刷新/已读等操作）
  extend(IndexPage.prototype, 'viewItems', function (items) {
    if (!isCommunityReadOnlyUser()) return;
    items.remove('sort');
  });

  // 首页：强制默认按“最新回复”展示（仅在无显式 sort 参数时）
  extend(IndexPage.prototype, 'oncreate', function () {
    if (!isCommunityReadOnlyUser()) return;
    // 注意：若站点默认排序本就是 latest，changeSort('latest') 会删除 sort 参数，
    // 从而导致这里反复触发（forced refresh 循环，产生大量 /api/discussions 请求）。
    // 因此只在“默认排序不是 latest 且当前无 sort 参数”时切一次。
    const p = app.search.params() || {};
    const defaultSort = (() => {
      try {
        return Object.keys(app.discussions.sortMap() || {})[0] || '';
      } catch (e) {
        return '';
      }
    })();
    const key = '__acme_latest_sort_bootstrapped__';
    if (!p.sort && defaultSort && defaultSort !== 'latest' && !app.cache[key]) {
      app.cache[key] = true;
      try {
        app.search.changeSort('latest');
      } catch (e) {
        // ignore
      }
    }

    // 兜底：少数主题/扩展可能在别处注入“发帖功能已关闭”按钮，这里直接移除对应节点，避免残留文案。
    try {
      document.querySelectorAll('.IndexPage-newDiscussion, .IndexPage .IndexPage-newDiscussion').forEach((el) => el.remove());
    } catch (e) {
      // ignore
    }
  });

  // 个人菜单：隐藏“个人主页/设置”，只保留退出（管理员不受影响）
  extend(SessionDropdown.prototype, 'items', function (items) {
    if (!isCommunityReadOnlyUser()) return;
    items.remove('profile');
    items.remove('settings');
  });
});
